import { Tab as HeadlessTab } from "@headlessui/react";
import { rem } from "polished";
import styled, { css } from "styled-components";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { ColorLabels } from "@/components/editor/utils/use-color";
import noScrollBar from "@/styles/no-scrollbar";

const DayWrapper = styled.span`
  display: flex;
  align-items: center;
`;

const DayNumber = withViewportStyle("span")`
  font-size: ${rem(32)};
  line-height: ${rem(42)};

  ${(props) => props.$viewport.tablet`
    font-size: ${rem(24)};
    line-height: ${rem(32)};
  `}
`;

const TabList = withViewportStyle(HeadlessTab.List)`
  width: ${rem(320)};
  flex-shrink: 0;
  background: none;
  display: flex;
  flex-direction: column;
  font-family: ${({ theme }) =>
    theme.fontImports[0]?.font?.name ?? theme.fonts[0].value};
  ${noScrollBar};

  ${(props) => props.$viewport.tablet`
    width: 100%;
    flex-direction: row;
  `}
`;

const Tab = styled(HeadlessTab)`
  ${({ theme }) => {
    const selectedBgColor = theme.colors[ColorLabels.SECONDARY];
    const background = theme.colors[ColorLabels.BACKGROUND];
    const foreground = theme.colors[ColorLabels.PRIMARY_FONT];

    return css`
      background: ${background};
      border: none;
      padding: ${rem(16)};
      outline: none;
      text-align: left;
      color: ${foreground};
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      gap: ${rem(8)};

      &[data-headlessui-state~="selected"] {
        background: ${selectedBgColor};

        :active {
          background: ${selectedBgColor};
        }
      }

      :active {
        background: ${background};
      }
    `;
  }}
`;

const Tabs = HeadlessTab.Group;
const TabPanel = HeadlessTab.Panel;
const TabPanels = HeadlessTab.Panels;

export { Tabs, TabList, Tab, TabPanel, TabPanels, DayWrapper, DayNumber };
